import { Component } from '@angular/core';
/**
 * @example 
 * {
 *  "props": {
 *    "templateId": "hero-image",
 *    "imageUrl": "assets/img/admin-panel.webp"
 *    "heroTitle": "Pannello amministrativo"
 *  }
 * }
 */
@Component({
  selector: 'app-hero-image',
  templateUrl: './hero-image.component.html',
  styleUrls: ['./hero-image.component.scss']
})
export class HeroImageComponent {
  data!: any | undefined;

}
